import { render, staticRenderFns } from "./AvaliacaoCreate.vue?vue&type=template&id=438801fd&scoped=true&"
import script from "./AvaliacaoCreate.vue?vue&type=script&lang=js&"
export * from "./AvaliacaoCreate.vue?vue&type=script&lang=js&"
import style0 from "./AvaliacaoCreate.vue?vue&type=style&index=0&id=438801fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438801fd",
  null
  
)

export default component.exports